module.exports = __webpack_public_path__ + "img/profiles.643ddf59.svg";